<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Пользователь</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProperty">
    <mat-option *ngFor="let user of filteredOptions | async | async" [value]="user">
      {{ user.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
